import { createAsyncThunk } from '@reduxjs/toolkit';
import { PlacementService } from '../../../epics/region_services/placement';
import { PlacementAllService } from '../../../epics/region_services/placement/all';
import {
    addPlacementKey,
    deletePlacementKey,
    editPlacementKey,
    getPlacementKey,
    getPlacementListKey,
    placementAllKey,
    placementAllListKey,
    placementNoAccountKey,
    placementNoAccountListKey,
    updatePlacementKey,
} from './placementKeys';
import { clearNamePlacement } from '../../common/placement_reducers/namePlacement';
import { clearTypePlacement } from '../../common/placement_reducers/typePlacement';
import { clearPlacementKey } from '../../common/thunkKeys/placementThunksKeys';
import {
    getNamePlacement,
    getTypePlacement,
} from '../../common/thunks/placementThunks';

export const addPlacement = createAsyncThunk(
    addPlacementKey,
    async (values, thunkAPI) => {
        try {
            return await PlacementService.addPlacement(values);
        } catch (error) {
            return thunkAPI.rejectWithValue({
                message: error?.message || error?.error || 'unknown',
                details: error?.details || null,
            });
        }
    },
);

export const getPlacement = createAsyncThunk(
    getPlacementKey,
    async (id, thunkAPI) => {
        try {
            const response = await PlacementService.getPlacement(id);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getPlacementList = createAsyncThunk(
    getPlacementListKey,
    async (payload, thunkAPI) => {
        try {
            const response = await PlacementService.getPlacementList(payload);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const deletePlacement = createAsyncThunk(
    deletePlacementKey,
    async (id, thunkAPI) => {
        try {
            const response = await PlacementService.deletePlacement(id);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const editPlacement = createAsyncThunk(
    editPlacementKey,
    async (updates, thunkAPI) => {
        try {
            const response = await PlacementService.editPlacement(updates);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const updatePlacement = createAsyncThunk(
    updatePlacementKey,
    async (updates, thunkAPI) => {
        try {
            const response = await PlacementService.updatePlacement(updates);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getPlacementAllList = createAsyncThunk(
    placementAllListKey,
    async (payload, thunkAPI) => {
        try {
            const response = await PlacementAllService.getPlacementAllList(payload);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getPlacementAll = createAsyncThunk(
    placementAllKey,
    async (id, thunkAPI) => {
        try {
            const response = await PlacementAllService.getPlacementAll(id);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getPlacementNoAccountList = createAsyncThunk(
    placementNoAccountListKey,
    async (payload, thunkAPI) => {
        try {
            const response =
                await PlacementAllService.getPlacementNoAccountList(payload);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getPlacementNoAccount = createAsyncThunk(
    placementNoAccountKey,
    async (id, thunkAPI) => {
        try {
            const response =
                await PlacementAllService.getPlacementNoAccount(id);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const clearPlacementDataAction = createAsyncThunk(
    clearPlacementKey,
    (_, { dispatch }) => {
        dispatch(clearNamePlacement());
        dispatch(clearTypePlacement());

        dispatch(getNamePlacement());
        dispatch(getTypePlacement());
    },
);
